export const initialState = {
    step: { stepId: 0, stepName: "Loading" },
    loading: true,
    newFtmId: 0,
    ftm: null,
    commonSettings: null,
    isCompletedRegistration: false
}